import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export interface InEditorDirectStreamingPluginState {
	affectedAnnotationIds?: string[];
	aiContentEndPos?: number;
	chunkNumber: number;
	isFinalStream?: boolean;
	isStreaming?: boolean;
	isStreamingFinished?: boolean;
	loadingPos?: number;
	showAIContentHighlight?: boolean;
	showHighlight?: boolean;
	showTelepointer?: boolean;
	startPos?: number;
	streamTimeStamp?: number;
	telepointerPos?: number;
	userContentEndPos?: number;
}

export const inEditorDirectStreamingPluginKey: PluginKey<InEditorDirectStreamingPluginState> =
	new PluginKey<InEditorDirectStreamingPluginState>('inEditorDirectStreaming');
